import Banner1 from "../components/image/Banner1.jpg";
import Banner2 from "../components/image/Banner2.jpg";
import Banner3 from "../components/image/Banner3.jpg";
import Banner4 from "../components/image/Banner4.jpg";
import Kd1 from "../components/image/kd1.jpg";

export const ADMISSIONS_PAGES = [
  {
    path: "/admissions",
    eyebrow: "Admissions",
    title: "Admissions Open for the 2026/2027 Academic Session",
    description:
      "Admissions are now open for the 2026/2027 academic session at S-TEE Schools. Families can begin the journey into Nursery, Primary, and Secondary with clear guidance from our admissions office in Festac.",
    heroImage: Banner1,
    heroImageAlt: "Admissions welcome section",
    heroActions: [
      { label: "Apply to S-TEE", path: "/admissions/apply", variant: "primary" },
      { label: "Online School", path: "/admissions/online-school", variant: "secondary" },
      { label: "Contact Admissions", path: "/contact", variant: "ghost" },
    ],
    stats: [
      { value: "2026/2027", label: "current session" },
      { value: "Nursery to Secondary", label: "entry pathway" },
      { value: "Mon - Fri", label: "8:00 A.M. - 2:00 P.M." },
    ],
    focus: {
      label: "Admissions Overview",
      title: "A clearer admissions path for families joining S-TEE",
      text:
        "S-TEE Schools provides a well-structured learning environment that promotes academic excellence, character development, discipline, and holistic growth for every child. Families can begin here to understand the admissions journey before moving into the full application details.",
      list: [
        "Admission is currently open into Nursery, Primary, and Secondary entry classes for the 2026/2027 academic year.",
        "Families can compare the campus route with the online school route without losing context.",
        "The admissions office is available during official working hours to answer practical questions before application.",
      ],
    },
    callout: {
      label: "Admissions Office",
      title: "Visit the admissions office or reach out before you apply",
      text:
        "Parents and guardians are encouraged to visit the admissions office for enquiries and guidance. The team is available from Monday to Friday, 8:00 A.M. to 2:00 P.M., to help with forms, class guidance, and next-step questions.",
      ctaLabel: "Contact S-TEE",
      ctaPath: "/contact",
    },
    cardsSection: {
      label: "Why Families Start Here",
      title: "The strengths the admissions message should communicate quickly",
      items: [
        {
          title: "Structured Learning Environment",
          text:
            "S-TEE positions its admissions offer around a learning environment that is organized, disciplined, and designed to support strong academic growth.",
        },
        {
          title: "Academic and Character Formation",
          text:
            "The school presents admissions not only as access to lessons, but as entry into a culture of character, leadership, and responsible conduct.",
        },
        {
          title: "Safe and Conducive Schooling",
          text:
            "Families are reassured by the emphasis on a safe, child-centered environment with experienced staff and visible academic structure.",
        },
      ],
    },
    statementSection: {
      label: "Classes Open for Admission",
      title: "Current entry points for the 2026/2027 session",
      text:
        "Families can currently enquire about the following admission levels:",
      items: [
        "Nursery School: Nursery 1, Nursery 2, and Nursery 3.",
        "Primary School: Grade 1 through Grade 6.",
        "Secondary School: JSS 1 to JSS 3 and SS 1.",
      ],
      note:
        "Families who need class-specific guidance can still contact the school directly before they begin the application process.",
    },
    stepsSection: {
      label: "Admission Process Overview",
      title: "The main process at a glance",
      items: [
        {
          title: "Purchase the admission form",
          text:
            "Admission forms are available through the school's admissions office as the first formal step into the S-TEE process.",
        },
        {
          title: "Submit the form and sit for assessment",
          text:
            "After submitting the completed form, candidates are guided into the placement or entrance assessment that helps determine readiness and suitability.",
        },
        {
          title: "Receive admission offer and complete fee payment",
          text:
            "Successful candidates receive admission guidance and are expected to complete the required fee payment before final class placement.",
        },
      ],
    },
    directorySection: {
      label: "Admissions Contacts",
      title: "How to speak with the admissions team",
      items: [
        {
          title: "Visit the Office",
          lines: [
            "Monday to Friday",
            "8:00 A.M. - 2:00 P.M.",
            "5th Avenue, H Close, Festac Town, Lagos.",
          ],
        },
        {
          title: "Phone and WhatsApp",
          lines: [
            "Calls: +234 707 515 2920",
            "WhatsApp: +234 704 567 1842",
            "Use these lines for enquiries and admissions guidance.",
          ],
        },
        {
          title: "Next Step",
          lines: [
            "Review the full application guide for the detailed admission process and required documents.",
            "Families comparing both options can also continue into the online school page from here.",
          ],
          ctaLabel: "View Full Application Guide",
          ctaPath: "/admissions/apply",
        },
      ],
    },
    faqSection: {
      label: "Admissions FAQ",
      title: "Questions families often ask first",
      items: [
        {
          question: "Which classes are currently open for admission?",
          answer:
            "Current admission entry points include Nursery 1 to 3, Grade 1 to 6, JSS 1 to 3, and SS 1.",
        },
        {
          question: "When can parents visit the admissions office?",
          answer:
            "Parents and guardians are encouraged to visit from Monday to Friday between 8:00 A.M. and 2:00 P.M. for enquiries and guidance.",
        },
        {
          question: "Can families compare campus admission and online school here?",
          answer:
            "Yes. Families can move from the main admissions overview into either the campus application or the online school route without confusion.",
        },
      ],
    },
    footerCta: {
      title: "Ready to review the full application process?",
      text:
        "Continue into the detailed Apply to S-TEE page for age guidance, required documents, admission steps, and the admissions calendar.",
      ctaLabel: "Open Apply to S-TEE",
      ctaPath: "/admissions/apply",
    },
  },
  {
    path: "/admissions/apply",
    eyebrow: "Apply to S-TEE",
    title: "Apply to S-TEE",
    description:
      "Our curriculum is a rich blend of national educational standards and a global worldview designed to raise world-class citizens. Families can review who can apply, what documents are needed, and how the full admissions journey works.",
    heroImage: Banner2,
    heroImageAlt: "Campus admissions journey",
    heroActions: [
      { label: "Back to Admissions", path: "/admissions", variant: "secondary" },
      { label: "Explore Online School", path: "/admissions/online-school", variant: "ghost" },
      { label: "Contact Admissions", path: "/contact", variant: "ghost" },
    ],
    stats: [
      { value: "6", label: "admission steps" },
      { value: "N15,000", label: "form fee" },
      { value: "3", label: "main entry stages" },
    ],
    focus: {
      label: "Details About Applying",
      title: "Families should understand age guidance, eligibility, and the route from form purchase to placement",
      text:
        "The admissions guide combines age guidance, class eligibility, the six-step admissions journey, and the supporting documents families should prepare before submission. Those practical details stay visible from the start.",
      list: [
        "Early Years and Nursery entry starts from age 3 for Junior Infant 1 on or before resumption.",
        "Primary entry expects children to be at least 6 years old on or before resumption for Grade 1.",
        "Secondary admission is restricted to JSS 1, JSS 2, and SS 1, subject to vacancies.",
      ],
    },
    callout: {
      label: "Admission Form",
      title: "The form is non-refundable and non-transferable",
      text:
        "The first step in gaining admission into S-TEE Schools is the purchase of the admission form for N15,000. Families are expected to complete the process carefully and return the form with the required supporting documents.",
      ctaLabel: "Speak With Admissions",
      ctaPath: "/contact",
    },
    cardsSection: {
      label: "Entry Guidance",
      title: "The main entry routes families should understand",
      items: [
        {
          title: "Early Years and Nursery",
          text:
            "S-TEE serves children in the Early Years category. Only children who are 3 years old on or before resumption can be placed in Junior Infant 1 (Nursery 1).",
        },
        {
          title: "Primary School",
          text:
            "Primary school gives children a structured academic progression. Only children who are 6 years old on or before resumption can be placed in Grade 1 (Primary 1).",
        },
        {
          title: "Secondary School",
          text:
            "Admission is restricted to JSS 1, JSS 2, and SS 1, subject to vacancies. Students seeking admission into SS 1 are required to submit their Junior School Certificate Examination result.",
        },
        {
          title: "Online School Option",
          text:
            "Families who need a location-flexible route can explore the S-TEE Online School and compare that pathway before choosing the campus application journey.",
        },
      ],
    },
    checklistSection: {
      label: "Things to Know First",
      title: "Required documents before you submit the form",
      text:
        "Prospective parents are expected to purchase the application form from the school's corporate office or online. After that, the completed admission form should be returned with the following documents:",
      items: [
        "2 recent passport photographs taken within the last 6 months.",
        "Photocopy of birth certificate.",
        "Photocopy of the data page of the international passport, where applicable.",
        "The last 3 academic results from the previous school.",
      ],
      note:
        "Documents not submitted through the online method can be submitted to S-TEE Schools, 5th Avenue, H Close, Festac Town, Amuwo Odofin, Lagos, Nigeria.",
    },
    stepsSection: {
      label: "Application Process",
      title: "The six-step route into S-TEE",
      items: [
        {
          title: "Purchase admission form",
          text:
            "Families begin by purchasing the non-refundable and non-transferable admission form.",
        },
        {
          title: "Submit the form",
          text:
            "Prospective parents are expected to submit the completed application form with all required supporting documents.",
        },
        {
          title: "Sit for entrance examination",
          text:
            "Prospective students sit for the entrance or placement examination to determine suitability for the class applied for.",
        },
        {
          title: "Attend the oral interview",
          text:
            "Shortlisted candidates proceed to the compulsory Know Your Student (KYS) oral interview with the admissions unit.",
        },
        {
          title: "Receive class placement",
          text:
            "Successful candidates are placed into suitable classes after the admissions review process is completed.",
        },
        {
          title: "Pay required fees",
          text:
            "Candidates who have been offered admission are expected to complete fee payment within the stated period to accept the offer.",
        },
      ],
    },
    timelineSection: {
      label: "Admissions Calendar",
      title: "When to apply to S-TEE Schools",
      columns: ["Stage", "Starts", "Ends"],
      rows: [
        { label: "Sale of form", start: "November", end: "April" },
        { label: "Entrance examinations", start: "March", end: "May" },
        { label: "Oral interview", start: "June", end: "August" },
      ],
    },
    directorySection: {
      label: "Submission Support",
      title: "Where to submit documents and what to do next",
      items: [
        {
          title: "Document Submission",
          lines: [
            "S-TEE Schools",
            "5th Avenue, H Close, Festac Town, Amuwo Odofin, Lagos, Nigeria.",
            "Documents not submitted online can be delivered here.",
          ],
        },
        {
          title: "Secondary Entry Note",
          lines: [
            "Prospective secondary students must be at least 10 years old by September of the year of admission.",
            "Applicants must have completed at least 5 years of primary education within or outside the country.",
          ],
        },
        {
          title: "Need Guidance?",
          lines: [
            "Families who want help before submitting can contact the admissions office directly for clarification on eligibility, class placement, and process timing.",
          ],
          ctaLabel: "Contact Admissions",
          ctaPath: "/contact",
        },
      ],
    },
    faqSection: {
      label: "Application FAQ",
      title: "Questions families ask while preparing to apply",
      items: [
        {
          question: "How much is the admission form?",
          answer:
            "The current admission form fee is N15,000, and the form is non-refundable and non-transferable.",
        },
        {
          question: "Does every candidate go through an interview?",
          answer:
            "Shortlisted candidates from the entrance examination are expected to sit for the Know Your Student (KYS) oral interview with the admissions unit.",
        },
        {
          question: "What documents should parents prepare first?",
          answer:
            "Families should prepare passport photographs, a birth certificate copy, passport data page where applicable, and the last 3 academic results from the previous school.",
        },
        {
          question: "Can families compare this with the online school route?",
          answer:
            "Yes. Families can compare the online school route with the campus application before deciding.",
        },
      ],
    },
    footerCta: {
      title: "Need a more flexible learning route?",
      text:
        "Families who want the S-TEE experience beyond the physical campus can continue into the online school journey.",
      ctaLabel: "View Online School",
      ctaPath: "/admissions/online-school",
    },
  },
  {
    path: "/admissions/online-school",
    eyebrow: "Online School",
    title: "Online School Registration",
    description:
      "You can now get the same rich world-class education S-TEE is known for irrespective of your location through the S-TEE Online School. The program was created to serve students outside the school's physical location who still want the S-TEE learning experience.",
    heroImage: Kd1,
    heroImageAlt: "Flexible online learning theme",
    heroActions: [
      { label: "Back to Admissions", path: "/admissions", variant: "secondary" },
      { label: "Contact Admissions", path: "/contact", variant: "ghost" },
    ],
    stats: [
      { value: "Anywhere", label: "location-flexible access" },
      { value: "Guided", label: "admissions support" },
      { value: "S-TEE Standard", label: "same learning direction" },
    ],
    focus: {
      label: "Program Overview",
      title: "The online school brings the S-TEE learning experience beyond the physical campus",
      text:
        "The S-TEE Online School started after the Covid-19 pandemic and is designed to cater for students who are outside the location of S-TEE Schools but still desire the same world-class education the school is known for. As online schooling continues to grow as an alternative to in-person education, the program now serves students both within and outside the school's immediate location.",
      list: [
        "A flexible route for families who cannot access the physical campus easily.",
        "A guided admissions conversation for parents who want to understand how remote learning works.",
        "A clear link back to campus admission for families still comparing both pathways.",
      ],
    },
    callout: {
      label: "Indicate Interest",
      title: "Families can register interest and hear from the admissions team",
      text:
        "Parents can begin the online school conversation through a simple interest form. Registered parents are contacted by the admissions office for the next step and further guidance.",
      ctaLabel: "Talk to Admissions",
      ctaPath: "/contact",
    },
    cardsSection: {
      label: "What Parents Need to Know",
      title: "Questions families ask first about online school",
      items: [
        {
          title: "Who the program serves",
          text:
            "The online school is designed for families who want the S-TEE academic direction but need a location-flexible learning route.",
        },
        {
          title: "How learning is supported",
          text:
            "Parents want clarity on communication, learner guidance, expectations at home, and how school support continues outside the campus.",
        },
        {
          title: "How to begin",
          text:
            "Parents should be able to indicate interest quickly and understand what happens after that.",
        },
      ],
    },
    statementSection: {
      label: "Interest Form Guidance",
      title: "Information parents should be ready to share",
      text:
        "Parents should prepare the following details before submission:",
      items: [
        "Student full name.",
        "Parent phone number and parent email address.",
        "City and country of residence.",
        "Student class or level of interest.",
      ],
      note:
        "Registered parents are contacted by the admissions office. For further enquiries, families can reach out through +2347045671842 or admission@steeschools.com.",
    },
    faqSection: {
      label: "Online School FAQ",
      title: "Common questions from families considering remote learning",
      items: [
        {
          question: "Is the online school part of the same S-TEE learning direction?",
          answer:
            "Yes. The online school is presented as an extension of the broader S-TEE academic experience rather than a disconnected alternative.",
        },
        {
          question: "What should parents prepare before indicating interest?",
          answer:
            "Parents should have the student's full name, contact details, city and country of residence, and the class of interest ready for the first conversation.",
        },
        {
          question: "Can families move back to the main admissions page easily?",
          answer:
            "Yes. Families can return to the main admissions hub and compare both routes without losing context.",
        },
      ],
    },
    directorySection: {
      label: "Online School Support",
      title: "Where to get help before the next step",
      items: [
        {
          title: "Admissions Office",
          lines: [
            "WhatsApp and enquiries: +2347045671842",
            "Admissions email: admission@steeschools.com",
            "Use this channel for online school questions and follow-up.",
          ],
        },
        {
          title: "Compare Both Routes",
          lines: [
            "Families who are still deciding can return to the main admissions hub and compare the online school with the campus route side by side.",
          ],
          ctaLabel: "Back to Admissions",
          ctaPath: "/admissions",
        },
      ],
    },
    footerCta: {
      title: "Need the wider admissions picture before deciding?",
      text:
        "Return to the admissions hub if you want to compare the campus application route with the online school option before proceeding.",
      ctaLabel: "Open Admissions",
      ctaPath: "/admissions",
    },
  },
  {
    path: "/admissions/prospectus",
    eyebrow: "Prospectus",
    title: "Download the S-TEE Prospectus",
    description:
      "The S-TEE prospectus brings the school story, programs, admissions direction, and next-step guidance together in one place before families make contact.",
    heroImage: Banner3,
    heroImageAlt: "Prospectus and school information theme",
    heroActions: [
      { label: "Back to Admissions", path: "/admissions", variant: "secondary" },
      { label: "Contact S-TEE", path: "/contact", variant: "ghost" },
    ],
    stats: [
      { value: "1", label: "main download destination" },
      { value: "Schoolwide", label: "information pack" },
      { value: "Simple", label: "family access" },
    ],
    focus: {
      label: "Why The Prospectus Helps",
      title: "Many families want one reliable document before they apply",
      text:
        "A strong prospectus brings the S-TEE story, academic overview, admissions direction, and student-life highlights together in one place. Even before a final PDF is linked, families should know what they will find inside.",
      list: [
        "Keep brochure or download access near the top for quick visibility.",
        "Summarize school overview, academics, admissions, and student-life highlights clearly.",
        "Keep admissions and contact close so the next conversation is easy to start.",
      ],
    },
    cardsSection: {
      label: "What Families Expect Inside",
      title: "The sections that make a prospectus genuinely useful",
      items: [
        {
          title: "School Overview",
          text:
            "A concise introduction to the S-TEE story, educational direction, and values that shape the school environment.",
        },
        {
          title: "Programs and Admissions",
          text:
            "A summary of available learning stages, admissions guidance, and the major next steps families should understand.",
        },
        {
          title: "Student Life",
          text:
            "Highlights that show what school life feels like beyond the classroom, including culture, events, and campus atmosphere.",
        },
      ],
    },
    directorySection: {
      label: "Prospectus Checklist",
      title: "Helpful support around the prospectus",
      items: [
        {
          title: "Main Download Area",
          lines: [
            "Download the current S-TEE prospectus here when it is available.",
            "Use the prospectus to review the school story, programs, and admissions details in one place.",
          ],
        },
        {
          title: "Need Help After Reading?",
          lines: [
            "Families comparing several schools often need a follow-up conversation after reviewing the prospectus.",
            "Contact the admissions team or return to the admissions journey when you are ready for the next step.",
          ],
          ctaLabel: "Contact S-TEE",
          ctaPath: "/contact",
        },
      ],
    },
    footerCta: {
      title: "Want the latest school notices alongside the prospectus?",
      text:
        "Families who want current admissions and school updates can continue into the latest news section.",
      ctaLabel: "View Latest News",
      ctaPath: "/admissions/latest-news",
    },
  },
  {
    path: "/admissions/latest-news",
    eyebrow: "Latest News",
    title: "School News, Notices, and Admissions Updates",
    description:
      "Find current admissions notices, resumption updates, and school information in one place.",
    heroImage: Banner4,
    heroImageAlt: "School announcements and updates theme",
    heroActions: [
      { label: "Back to Admissions", path: "/admissions", variant: "secondary" },
      { label: "Apply to S-TEE", path: "/admissions/apply", variant: "ghost" },
    ],
    stats: [
      { value: "Current", label: "family updates" },
      { value: "Visible", label: "important notices" },
      { value: "Central", label: "school news page" },
    ],
    focus: {
      label: "What to Publish Here",
      title: "Current notices, deadlines, and important reminders",
      text:
        "A dedicated updates page helps parents know where to check for the most relevant school information instead of depending on scattered messages or outdated notices.",
      list: [
        "Admissions deadlines and new-session information.",
        "Resumption notices and operational updates.",
        "School highlights that show progress, wins, and community life.",
      ],
    },
    callout: {
      label: "Why It Works",
      title: "Active school updates make the whole website feel more alive",
      text:
        "When families see current notices, they feel reassured that the school communicates clearly and keeps important information visible.",
      ctaLabel: "Open Admissions Hub",
      ctaPath: "/admissions",
    },
    cardsSection: {
      label: "Post Ideas",
      title: "The update categories that keep families informed",
      items: [
        {
          title: "Admissions Deadlines",
          text:
            "Keep session openings, application reminders, and important timelines where parents can find them quickly.",
        },
        {
          title: "School Notices",
          text:
            "Use short and clear posts for resumption updates, operational changes, or family reminders.",
        },
        {
          title: "Community Highlights",
          text:
            "Celebrate achievements, events, and school moments that help visitors feel the atmosphere and momentum of the institution.",
        },
      ],
    },
    newsSection: {
      label: "Recent Updates",
      title: "A clearer format for current school notices",
      items: [
        {
          tag: "Admissions",
          meta: "January 28, 2026",
          title: "Admissions open for the 2026/2027 academic session",
          text:
            "Admissions are currently open into Nursery, Primary, and Secondary classes, making this one of the most important updates for prospective families.",
        },
        {
          tag: "Notice",
          meta: "September 4, 2025",
          title: "Back-to-school resumption notice",
          text:
            "Current term information stays easier to follow when resumption details are kept in one visible place.",
        },
        {
          tag: "School Life",
          meta: "June 16, 2023",
          title: "Student wellbeing and positive habits",
          text:
            "School updates can also include practical learner-support content that helps families stay connected to the school's wider educational voice.",
        },
      ],
    },
    footerCta: {
      title: "Want to move from updates into application?",
      text:
        "Families who are ready to proceed can move directly from current notices into the application journey.",
      ctaLabel: "Apply to S-TEE",
      ctaPath: "/admissions/apply",
    },
  },
];
